<template>
  <v-row justify="center">
    <v-dialog :value="dialog" max-width="600" persistent @input="closeModal">
      <v-card class="card">
        <v-card-title class="headline accent--text pb-4">
          {{ isShowMode ? 'Просмотр' : isEdit ? 'Редактировать' : 'Добавить' }}
        </v-card-title>
        <v-card-text outlined tile class="border-top">
          <v-container class="px-0">
            <v-row>
              <v-col cols="12" class="py-0 pt-5">
                <v-autocomplete
                  class="pt-3 mt-0 required"
                  v-model="submissionSession.academyYear"
                  :items="academyYear"
                  :disabled="isShowMode"
                  item-text="name"
                  clearable
                  label="Учебный год"
                  placeholder="Выберите из списка"
                  return-object
                  @input="$v.submissionSession.academyYear.$touch()"
                  @blur="$v.submissionSession.academyYear.$touch()"
                  :error-messages="errorMessages.academyYear"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-autocomplete
                  class="pt-3 mt-0 required"
                  v-model="submissionSession.semesterType"
                  :items="semesterType"
                  :disabled="isShowMode"
                  item-text="name"
                  clearable
                  label="Семестр"
                  placeholder="Выберите из списка"
                  return-object
                  @input="$v.submissionSession.semesterType.$touch()"
                  @blur="$v.submissionSession.semesterType.$touch()"
                  :error-messages="errorMessages.semesterType"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-autocomplete
                  class="pt-3 mt-0 required"
                  v-model="submissionSession.current"
                  :items="current"
                  :disabled="isShowMode"
                  item-text="name"
                  clearable
                  label="Текущий период подачи"
                  placeholder="Выберите из списка"
                  return-object
                  @input="$v.submissionSession.current.$touch()"
                  @blur="$v.submissionSession.current.$touch()"
                  :error-messages="errorMessages.current"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="submissionSession.submissionCode"
                  :disabled="isShowMode"
                  label="Код"
                  placeholder="Введите код"
                  @input="$v.submissionSession.submissionCode.$touch()"
                  @blur="$v.submissionSession.submissionCode.$touch()"
                  :error-messages="errorMessages.submissionCode"
                />
              </v-col>

              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="submissionSession.submissionName"
                  :disabled="isShowMode"
                  label="Имя"
                  placeholder="Введите имя"
                  @input="$v.submissionSession.submissionName.$touch()"
                  @blur="$v.submissionSession.submissionName.$touch()"
                  :error-messages="errorMessages.submissionName"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="px-6">
          <v-spacer></v-spacer>
          <v-btn text color="lightGrey" @click="closeModal"> {{ isShowMode ? 'Закрыть' : 'Отмена' }} </v-btn>
          <v-btn
            v-if="!isShowMode"
            :loading="saveBtnLoading"
            :disabled="$v.$invalid || isShowMode"
            color="success"
            text
            @click="saveSubmissionSession"
          >
            {{ isEdit ? 'Сохранить' : 'Создать' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { SubmissionSession } from '@/models'
import { acadamyYearApi, semesterTypeApi } from '@/api'
import { setValidateMessages } from '@/scripts/validation'

export default {
  props: {
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    dialog: Boolean,
    selectedItem: SubmissionSession
  },

  async created() {
    await this.loadCatalogs()
  },

  data: () => ({
    submissionSession: new SubmissionSession(),
    current: [
      {
        value: true,
        name: 'Да'
      },
      {
        value: false,
        name: 'Нет'
      },
    ],
    academyYear: [],
    semesterType: [],
  }),

  validations() {
    return {
      submissionSession: {
        academyYear: { required },
        semesterType: { required },
        current: { required },
        submissionCode: { required },
        submissionName: { required },
      }
    }
  },

  computed: {
    isEdit() {
      return this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.submissionSession.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.submissionSession[key])
      })

      return allErrors
    }
  },

  methods: {
    async loadCatalogs() {
      const [acadamyYear,semesterType] = await Promise.all([acadamyYearApi.getCatalog(), semesterTypeApi.getCatalog()])
      this.academyYear = acadamyYear
      this.semesterType = semesterType
    },

    saveSubmissionSession() {
      this.$emit('saveSubmissionSession', this.submissionSession.getForAPI())
    },

    resetModal() {
      this.$v.$reset()
      this.submissionSession = new SubmissionSession()
    },

    closeModal() {
      this.submissionSession = new SubmissionSession()
      this.$emit('closeModal')
    }
  },

  watch: {
    selectedItem(val) {
      this.submissionSession = val ? SubmissionSession.buildFromAPI(val) : new SubmissionSession()
    },

    dialog(val) {
      !val && this.resetModal()
    }
  }
}
</script>

<style scoped>
.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.card >>> .v-label.theme--light {
  font-size: 14px;
  color: rgba(55, 71, 79, .8) !important;
}

.card >>> .v-label.v-label--active.theme--light {
  font-size: 16px;
}

.card >>> .v-label.v-label--active.primary--text.theme--light {
  color: #2196f3 !important
}
</style>